/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import MarketplaceTooltip from '../MarketplaceTooltip/MarketplaceTooltip';


const MarketplaceShortcodes = function MarketplaceShortcodesFunction({
  identifier,
  attributes,
  tooltip,
  styleFlag,
}) {
  switch (identifier) {
    case 'MarkdownTooltip':
      return (
        <MarketplaceTooltip
          display
          hideIcon
          title={attributes.title}
          message={tooltip.message}
          styleFlag={styleFlag}
        />
      );
    default:
      return null;
  }
};

MarketplaceShortcodes.propTypes = {
  identifier: PropTypes.string.isRequired,
  attributes: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  tooltip: PropTypes.shape({
    message: PropTypes.string,
  }),
  styleFlag: PropTypes.string,
};

MarketplaceShortcodes.defaultProps = {
  tooltip: undefined,
  styleFlag: 'inline',
};

export default MarketplaceShortcodes;
